import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=a591f988"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports